<template>
    <div class="row">
        <div class="col-md-12 col-xl-12 col-xm-12">
            <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
                <Form ref="redeForm" @submit="soumettre" :validation-schema="contratSchema">
                    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
                        <h5 class="card-title fw-bold mb-15 mb-lg-20 mb-xl-25"></h5>
                        <div class="border p-2 p-lg-4 border-dark border-opacity-10">
                            <div class="row">
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label for="reference" class="form-label fw-medium text-black">
                                            Référence
                                        </label>
                                        <Field name="reference" v-model="reference"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="reference" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label for="annee" class="form-label fw-medium text-black">
                                            Année <span class="text-danger">*</span>
                                        </label>
                                        <Field name="annee" v-slot="{ field }" v-model="annee">
                                            <Multiselect :options="anneesOptions" :searchable="true"
                                                v-model="field.value" v-bind="field"
                                                placeholder="Sélectionner une année" />
                                        </Field>
                                        <ErrorMessage name="annee" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label class="d-block text-black fw-semibold mb-10">
                                            Date début <span class="text-danger">*</span>
                                        </label>
                                        <Field name="dateDebut" type="date" v-model="dateDebut"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="dateDebut" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label for="contrat" class="form-label fw-medium text-black">
                                            Contrat / Usager <span class="text-danger">*</span>
                                        </label>
                                        <Field name="contrat" v-model="contrat"
                                            class="form-control shadow-none fs-md-15 text-black" v-slot="{ field }">
                                            <Multiselect v-model="field.value" v-bind="field" :filter-results="false"
                                                :min-chars="2" :resolve-on-load="false" :delay="0" :searchable="true"
                                                :options-limit="300" :options="async (query) => {
                                                    if (query.length >= 3) {
                                                        const results = await reupererContrat(query);
                                                        if (results && results.length > 0) {
                                                            return results;
                                                        } else {
                                                            return [
                                                                { value: '', label: 'Aucun enregistrement trouvé' },
                                                            ];
                                                        }
                                                    } else {
                                                        return [];
                                                    }
                                                }" noOptionsText="Tapez au moins deux caractères"
                                                placeholder="Rechercher un contrat" />
                                        </Field>
                                        <ErrorMessage name="contrat" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-3 col-xm-12 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label class="d-block text-black fw-semibold mb-10">
                                            Agent <span class="text-danger">*</span>
                                        </label>
                                        <Field name="agent" v-slot="{ field }" v-model="agent"
                                            class="form-control shadow-none fs-md-15 text-black">
                                            <Multiselect v-model="field.value" v-bind="field" :options="agentOptions"
                                                :searchable="true" noResultText="Aucun enregistrement trouvé"
                                                placeholder="Rechercher un percepteur" />
                                        </Field>
                                        <ErrorMessage name="agent" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-3 col-xm-12 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label class="form-label fw-medium text-black">
                                            Mois payé <span class="text-danger">*</span>
                                        </label>
                                        <Field name="periode" v-slot="{ field }" v-model="periode">
                                            <Multiselect :options="moisPayesOptions" mode="tags" multiple="true"
                                                :searchable="true" v-model="field.value" v-bind="field"
                                                placeholder="Sélectionner une période" />
                                        </Field>
                                        <ErrorMessage name="periode" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label class="form-label fw-medium text-black">
                                            Mode de paiement <span class="text-danger">*</span>
                                        </label>
                                        <Field name="mode" v-slot="{ field }" v-model="mode">
                                            <Multiselect :options="modes" :searchable="true" v-model="field.value"
                                                v-bind="field" placeholder="Sélectionner un mode" />
                                        </Field>
                                        <ErrorMessage name="mode" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-12" v-if="showTransactionIdField">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label class="form-label fw-medium text-black">
                                            Référence externe
                                            <span class="text-danger">*</span>
                                        </label>
                                        <Field type="text" name="transactionId" v-model="transactionId"
                                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'ID de transaction" />
                                        <ErrorMessage name="transactionId" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label for="mois" class="form-label fw-medium text-black">
                                            Nombre de mois <span class="text-danger">*</span>
                                        </label>
                                        <Field name="mois" v-model="mois" :disabled="true"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="mois" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label for="montant" class="form-label fw-medium text-black">
                                            Montant
                                        </label>
                                        <Field name="montant" v-model="montant" :disabled="true"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="montant" class="text-danger" />
                                    </div>
                                </div>

                                <!-- Section fichiers justificatifs -->
                                <div class="col-md-12">
                                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                        <label class="form-label fw-medium text-black">
                                            Fichiers justificatifs
                                        </label>
                                        
                                        <!-- Zone de drop pour les fichiers -->
                                        <div class="dropzone-container mb-3">
                                            <div 
                                                class="dropzone-area"
                                                @drop="onDrop"
                                                @dragover.prevent
                                                @dragenter.prevent
                                                @click="triggerFileInput">
                                                <div class="dropzone-content" v-if="!hasFiles">
                                                    <i class="flaticon-gallery-1 fs-1 text-muted"></i>
                                                    <p class="mt-2">Glissez et déposez vos fichiers justificatifs ici</p>
                                                    <small class="text-muted">Formats acceptés: PDF, JPG, PNG (Max 10MB par fichier)</small>
                                                </div>
                                            </div>
                                            <input 
                                                ref="fileInput"
                                                type="file" 
                                                multiple 
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                @change="onFileSelect"
                                                style="display: none;" />
                                        </div>

                                        <!-- Liste des fichiers avec drag & drop -->
                                        <div v-if="fichiersJustificatifs.length > 0" class="files-list">
                                            <h6 class="mb-3">Fichiers sélectionnés ({{ fichiersJustificatifs.length }})</h6>
                                            <draggable 
                                                v-model="fichiersJustificatifs" 
                                                item-key="id"
                                                class="files-grid"
                                                @end="onDragEnd">
                                                <template #item="{ element, index }">
                                                    <div class="file-item">
                                                        <div class="file-preview">
                                                            <img v-if="isImage(element.file)" :src="element.preview" alt="Preview" class="file-thumbnail" />
                                                            <div v-else class="file-icon">
                                                                <i class="flaticon-file-1"></i>
                                                            </div>
                                                        </div>
                                                        <div class="file-info">
                                                            <p class="file-name">{{ element.file.name }}</p>
                                                            <p class="file-size">{{ formatFileSize(element.file.size) }}</p>
                                                        </div>
                                                        <div class="file-actions">
                                                            <button 
                                                                type="button" 
                                                                class="btn btn-sm btn-outline-danger"
                                                                @click="removeFile(index)">
                                                                <i class="flaticon-delete"></i>
                                                            </button>
                                                        </div>
                                                        <div class="drag-handle">
                                                            <i class="flaticon-menu"></i>
                                                        </div>
                                                    </div>
                                                </template>
                                            </draggable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-15 p-sm-20 p-md-25 p-lg-30 bg-white text-end">
                        <button v-show="valideEtape1"
                            class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                            type="submit">
                            Payer
                        </button>
                        <button
                            class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                            type="button" v-show="!valideEtape1" disabled>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span class="visually-hidden">Chargement...</span>
                        </button>
                        <router-link to="/liste-paiement" class="btn btn-danger transition border-0 lh-1 fw-medium"><i
                                class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                            <span class="position-relative"></span>Annuler
                        </router-link>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, reactive, toRef, onMounted, computed } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import {
    error,
    success,
    format_date,
    telechargerFichier2,
    getUrlApiForFiles,
} from "@/utils/utils";
import { useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import JwtService from "@/services/JwtService";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import {
    openKkiapayWidget,
    addKkiapayListener,
    removeKkiapayListener,
} from "kkiapay";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { KKIAPAY } from "@/models/KKIAPAY";
import router from "@/router";
import draggable from 'vuedraggable';

export default defineComponent({
    name: "AddPaiement",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect,
        draggable,
    },
    setup(props, { emit }) {
        const contratSchema = Yup.object().shape({
            agent: Yup.number().required("L'agent est obligatoire"),
            contrat: Yup.number().required("Le contrat est obligatoire"),
            periode: Yup.array().required("Séléctionnez au moins une période"),
            mode: Yup.number().required("Sélectionnez un mode de paiement"),
            dateDebut: Yup.string().required("La date de paiement est obligatoire"),
            reference: Yup.string().notRequired().length(15, "La référence doit avoir 15 caractères"),
            mois: Yup.number().required("Nombre de mois est obligatoire").positive().integer().min(1, "Le nombre de mois minimal est 1").default(0),
            annee: Yup.number().required("Nombre de mois est obligatoire").positive().integer(),
            montant: Yup.number().required("Montant est obligatoire").positive().min(1000, "Le montant minimal est de 1000 F CFA").default(0),
            transactionId: Yup.string()
                .nullable()
                .test("transactionId-required", "La référence externe du paiement est obligatoire", function (value) {
                    const mode = this.parent.mode;
                    if (mode !== 1 && mode !== 2 && mode !== 0) {
                        return value !== null && value !== undefined && value.trim() !== "";
                    }
                    return true;
                }),
        });

        const dateDebut = ref(null);
        const agent = ref();
        const reference = ref(null);
        const annee = ref(null);
        const valideEtape1 = ref(true);
        const periode = ref<any[]>([]);
        const impayeOptions = ref([]);
        const mois = ref(0);
        const mode = ref(null);
        const modes = ref([]);
        const montant = ref(0);
        const impp = ref(null);
        const loyer = ref(0);
        const impayes = ref([]);
        const contrats = ref([]);
        const contrat = ref(null);
        const usager = ref('');
        const lesContrats = ref<any[]>([]);
        const transactionId = ref("");
        
        // Computed pour déterminer si on doit afficher le champ transactionId
        const showTransactionIdField = computed(() => {
            return mode.value !== null && mode.value !== undefined && mode.value !== 0 && mode.value !== 1 && mode.value !== 2;
        });

        var check = reactive({
            typeError: "RAS",
            idTransaction: 0,
        });

        // Variables pour les fichiers justificatifs
        const fichiersJustificatifs = ref<any[]>([]);
        const hasFiles = ref(false);
        const fileInput = ref<HTMLInputElement | null>(null);
        let fileIdCounter = 0;

        const reupererMode = async () => {
            try {
                const response = await ApiService.get("listeMode");
                if (response.data) {
                    return (modes.value = response.data.data.map((el) => {
                        return {
                            value: el.id,
                            label: el.libelle,
                        };
                    }));
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
            }
        };
        const agentOptions = ref();
        const getUser = async () => {
            try {
                const response = await axios.get("/tout/users");
                const donnee = response.data.data;
                agentOptions.value = donnee.map((agent) => ({
                    value: agent.id,
                    label: agent.nomComplet,
                }));
            } catch (error) {
                //
            }
        };
        const reupererContrat = async (recherche) => {
            try {
                impp.value = null;
                impayes.value = [];
                const response = await ApiService.post("listeContrat", { recherche });
                lesContrats.value = response.data.data;
                if (response.data) {
                    return (contrats.value = response.data.data.map((el) => {
                        return {
                            value: el.id,
                            label: el.ref + " - Lo : " + el.locataire + " - Ex : " + el.exploitant,
                        };
                    }));
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
            }
        }
        const moisPayesOptions = [
            { value: "Janvier", label: "Janvier" },
            { value: "Février", label: "Février" },
            { value: "Mars", label: "Mars" },
            { value: "Avril", label: "Avril" },
            { value: "Mai", label: "Mai" },
            { value: "Juin", label: "Juin" },
            { value: "Juillet", label: "Juillet" },
            { value: "Août", label: "Août" },
            { value: "Septembre", label: "Septembre" },
            { value: "Octobre", label: "Octobre" },
            { value: "Novembre", label: "Novembre" },
            { value: "Décembre", label: "Décembre" },
        ];

        const currentYear = new Date().getFullYear();
        const anneesOptions = ref<any[]>([]);
        for (let i = currentYear - 4; i <= currentYear + 3; i++) {
            anneesOptions.value.push({ value: i, label: i.toString() });
        }

        // Fonctions pour la gestion des fichiers
        const triggerFileInput = () => {
            fileInput.value?.click();
        };

        const onDrop = (event: DragEvent) => {
            event.preventDefault();
            const files = event.dataTransfer?.files;
            if (files) {
                handleFiles(Array.from(files));
            }
        };

        const onFileSelect = (event: Event) => {
            const target = event.target as HTMLInputElement;
            const files = target.files;
            if (files) {
                handleFiles(Array.from(files));
            }
        };

        const handleFiles = (files: File[]) => {
            files.forEach(file => {
                // Vérifier la taille du fichier (10MB max)
                if (file.size > 10 * 1024 * 1024) {
                    error(`Le fichier ${file.name} est trop volumineux. Taille maximale: 10MB`);
                    return;
                }

                // Vérifier le type de fichier
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(file.type)) {
                    error(`Le fichier ${file.name} n'est pas un format accepté. Formats acceptés: PDF, JPG, PNG`);
                    return;
                }

                const newFile = {
                    id: ++fileIdCounter,
                    file: file,
                    preview: null as string | null,
                    order: fichiersJustificatifs.value.length
                };

                // Créer une preview si c'est une image
                if (isImage(file)) {
                    newFile.preview = URL.createObjectURL(file);
                }

                fichiersJustificatifs.value.push(newFile);
                hasFiles.value = true;
            });
        };

        const removeFile = (index: number) => {
            const file = fichiersJustificatifs.value[index];
            if (file.preview) {
                URL.revokeObjectURL(file.preview);
            }
            fichiersJustificatifs.value.splice(index, 1);
            hasFiles.value = fichiersJustificatifs.value.length > 0;
        };

        const onDragEnd = (event: any) => {
            // Mettre à jour l'ordre des fichiers
            fichiersJustificatifs.value.forEach((file, index) => {
                file.order = index;
            });
        };

        const isImage = (file: File): boolean => {
            return file.type.startsWith('image/');
        };

        const formatFileSize = (bytes: number): string => {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        };

        const soumettre = async (values, { resetForm }) => {
            valideEtape1.value = false;

            // Gestion des modes différents de 1 et 2
            if (values.mode !== 1 && values.mode !== 2 && values.mode > 2) {
                // Vérifier que transactionId est présent
                if (!values.transactionId || values.transactionId.trim() === "") {
                    error("La référence externe est obligatoire");
                    valideEtape1.value = true;
                    return;
                }

                // Avant soumission, configurer check
                check.typeError = "SUCCESS";
                check.idTransaction = values.transactionId;
                values["idTransaction"] = check.idTransaction;
                values["check"] = check;
            }

            const result = await Swal.fire({
                html: "<p>Voulez-vous vraiment effectuer ce paiement d'un montant de <b style='color:red;'>" + montant.value + "</b> F CFA pour l'usager " + usager.value + "? </p>",
                title: "Confirmation",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
            });
            if (result.isConfirmed) {
                try {
                    if(fichiersJustificatifs.value.length < 1){
                        error("Veuillez sélectionner au moins un fichier justificatif");
                        valideEtape1.value = true;
                        return;
                    }

                    // Créer FormData pour inclure les fichiers
                    const formData = new FormData();
                    
                    // Ajouter les données du formulaire
                    Object.keys(values).forEach(key => {
                        if (key === 'periode' && Array.isArray(values[key])) {
                            formData.append(key, JSON.stringify(values[key]));
                        } else if (key === 'check' && typeof values[key] === 'object' && values[key] !== null) {
                            // Gérer l'objet check : envoyer comme JSON stringifié
                            // Le backend devra parser ce JSON
                            formData.append('check', JSON.stringify(values[key]));
                        } else if (values[key] !== null && values[key] !== undefined && key !== 'autreFichier[]') {
                            formData.append(key, values[key]);
                        }
                    });

                    // Ajouter les fichiers justificatifs
                    fichiersJustificatifs.value.forEach((fileObj, index) => {
                        formData.append('autreFichier[]', fileObj.file);
                    });

                    const paiement = await axios.post("regularisation/paiement", formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Accept: "*/*"
                        }
                    });
                    
                    if (paiement.status == 201) {
                        resetForm();
                        fichiersJustificatifs.value = [];
                        hasFiles.value = false;
                        success("Paiement effectué avec succès");
                        router.push("/liste-paiement");
                    } else {
                        error("Une erreur s'est produite lors du paiement");
                    }
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response) {
                        error(err.response.data.message || err.message);
                    } else {
                        if (err instanceof Error) {
                            error(err.message);
                        } else {
                            error(String(err));
                        }
                    }
                } finally {
                    valideEtape1.value = true;
                }

            } else {
                valideEtape1.value = true;
            }

        };

        onMounted(async () => {
            await reupererMode();
            await getUser();
        });

        const calculMontant = () => {
            if (mois.value > 0 && loyer.value > 0) {
                montant.value = mois.value * loyer.value;
            } else {
                montant.value = 0;
            }
        }

        watch(contrat, async (value) => {
            if (value) {
                const contrat = lesContrats.value.find((el) => el.id === value);
                loyer.value = contrat.loyer;
                usager.value = contrat.usagers;
                await calculMontant();
            }
        });

        watch(() => periode.value, async (value: any[]) => {
            if (value) {
                mois.value = value.length;
                await calculMontant();
            }
        });

        return {
            periode,
            anneesOptions,
            reference,
            annee,
            contratSchema,
            reupererContrat,
            impayes,
            valideEtape1,
            mode,
            mois,
            modes,
            agent,
            agentOptions,
            soumettre,
            moisPayesOptions,
            montant,
            impayeOptions,
            impp,
            dateDebut,
            contrat,
            // Nouvelles propriétés pour les fichiers
            fichiersJustificatifs,
            hasFiles,
            fileInput,
            triggerFileInput,
            onDrop,
            onFileSelect,
            removeFile,
            onDragEnd,
            isImage,
            formatFileSize,
            transactionId,
            showTransactionIdField,
        };
    }
});
</script>

<style>
.clickable-row {
    cursor: pointer;
}

.clickable-row:hover {
    background-color: #bf6b6b;
}

.selected-row {
    border: 2px solid green;
    color: #fff;
    background-color: #0f4030;
}

/* Styles pour le dropzone */
.dropzone-container {
    margin-bottom: 20px;
}

.dropzone-area {
    border: 2px dashed #ddd;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    background: #f8f9fa;
    transition: all 0.3s ease;
    cursor: pointer;
}

.dropzone-area:hover {
    border-color: #007bff;
    background: #f0f8ff;
}

.dropzone-area.dragover {
    border-color: #28a745;
    background: #d4edda;
}

.dropzone-content {
    text-align: center;
}

.files-list {
    margin-top: 20px;
}

.files-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
    margin-top: 15px;
}

.file-item {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    background: white;
    position: relative;
    cursor: move;
    transition: all 0.3s ease;
}

.file-item:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transform: translateY(-2px);
}

.file-preview {
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 10px;
}

.file-thumbnail {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    border-radius: 4px;
}

.file-icon {
    font-size: 2rem;
    color: #6c757d;
}

.file-info {
    text-align: center;
}

.file-name {
    font-size: 0.875rem;
    font-weight: 500;
    margin: 0;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-size {
    font-size: 0.75rem;
    color: #6c757d;
    margin: 5px 0 0 0;
}

.file-actions {
    position: absolute;
    top: 5px;
    right: 5px;
}

.drag-handle {
    position: absolute;
    top: 5px;
    left: 5px;
    color: #6c757d;
    cursor: move;
}

.drag-handle:hover {
    color: #007bff;
}

/* Responsive */
@media (max-width: 768px) {
    .files-grid {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 10px;
    }
    
    .file-preview {
        height: 100px;
    }
}
</style>